import './styles.css';
import { resolveApplicationRoute } from './appRoute';
import { installApplicationBaseUrl } from './appUrl';
import { mountEventDemoInputDisplay } from './game/events/eventDemoInputDisplay';
import { mountEventDemoLauncher } from './game/events/eventDemoLauncher';
import { mountAthleteModelSwitcher } from './game/render/athleteModelStyle';

const root = document.querySelector<HTMLElement>('#app');
if (!root) throw new Error('Application root was not found.');

installApplicationBaseUrl(root);

const boot = async (): Promise<void> => {
  const route = resolveApplicationRoute(window.location);

  if (route.kind === 'progress') {
    const { mountProgressPage } = await import('./features/progress');
    mountProgressPage(root);
    return;
  }

  if (route.kind === 'beginner-tour') {
    const { mountBeginnerTour } = await import('./features/beginner-tour');
    mountBeginnerTour(root);
    return;
  }

  if (route.kind === 'campaign') {
    mountAthleteModelSwitcher();
    const { CampaignBrowser } = await import('./game/campaign/browser');
    new CampaignBrowser(root);
    return;
  }

  const event = route.eventId;
  mountEventDemoLauncher();
  mountEventDemoInputDisplay(event);
  mountAthleteModelSwitcher();

  if (event === 'long-jump') {
    const { LongJumpGame } = await import('./game/long-jump/LongJumpGame');
    new LongJumpGame(root);
    return;
  }

  if (event === 'shot-put') {
    const { ShotPutGame } = await import('./game/shot-put/ShotPutGame');
    new ShotPutGame(root);
    return;
  }

  if (event === 'high-jump') {
    const { HighJumpGame } = await import('./game/high-jump/HighJumpGame');
    new HighJumpGame(root);
    return;
  }

  if (event === '400m') {
    const { FourHundredGame } = await import('./game/400m/FourHundredGame');
    new FourHundredGame(root);
    return;
  }

  if (event === '110m-hurdles') {
    const { HurdlesGame } = await import('./game/110m-hurdles/HurdlesGame');
    new HurdlesGame(root);
    return;
  }

  if (event === 'discus') {
    const { DiscusGame } = await import('./game/discus/DiscusGame');
    new DiscusGame(root);
    return;
  }

  if (event === 'pole-vault') {
    const { PoleVaultGame } = await import('./game/pole-vault/PoleVaultGame');
    new PoleVaultGame(root);
    return;
  }

  if (event === 'javelin') {
    const { JavelinGame } = await import('./game/javelin/JavelinGame');
    new JavelinGame(root);
    return;
  }

  if (event === '1500m') {
    const { FifteenHundredGame } = await import('./game/1500m/FifteenHundredGame');
    new FifteenHundredGame(root);
    return;
  }

  const { DecathlonGame } = await import('./game/DecathlonGame');
  new DecathlonGame(root);
};

void boot();
